import React, { useEffect, useState, useRef, useContext} from 'react';
import { observer } from 'mobx-react-lite';
import {
  HrFlexContainer,
  HrCustomButton,
  HrTitleContainer,
  HrTitleH4,
  HrParagraph,
  HrTitleH5,
  HrGridContainer,
  HrSecondary,
  HrWhite,
  HrButtonHover,
  HrButtonActive,
  HrGrey,
  HrRed
} from '@components/styles/hr-styles';
import DropboxChooser from 'react-dropbox-chooser';
import useDrivePicker from 'react-google-drive-picker';
import { InputFile } from '@components/form/input';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import styled from 'styled-components';
import { LogoDrive, LogoDropbox } from '../../../utils/image-svg';
import useStore from '../../store/useStore';
import { DisplaySettingsContext } from '../../store/display-settings';

const GridContainer = styled(HrGridContainer)`
  grid-template-columns: repeat(3, minmax(150px, 250px));
  gap: 16px;

  @media (max-width: 550px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const FlexContainer = styled(HrFlexContainer)`
  flex-direction: column;
  align-items: flex-start;
  padding: 0 32px;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

const obligatory = 1;
const editAction = 'edit';

export const Curriculum = observer(
  ({ vacancyRequirement, clearErrors, formState, control, setValue, register, setError, action, trigger }) => {
    const inputRef = useRef();
    const [t] = useTranslation();
    const { errors } = formState;
    const [openPicker, authResponse] = useDrivePicker();
    const [fileSelected, setFileSelected] = useState({ name: '' });
    const { driveKey, clientAppDrive, _vacancy } = useStore();
    const { req_attachedFileTypes: reqAttachedFileTypes } = _vacancy;

    const getAttachedFileLabel = (attachedFileValue) => {
      const existsTranslationKey =
        attachedFileValue && i18n.exists(`postulant.curriculum.title.${reqAttachedFileTypes}`);

      return existsTranslationKey
        ? t(`postulant.curriculum.title.${reqAttachedFileTypes}`)
        : t(`postulant.curriculum.title.default`);
    };

    const attachedFileLabel = getAttachedFileLabel(reqAttachedFileTypes);

    const loadImageBlob = async (url, token) => {
      const options = {
        method: 'GET'
      };
      if (token) {
        const bearer = `Bearer ${token}`;
        options.headers = {
          Authorization: bearer
          // 'Content-Description': 'File Transfer'
        };
        options.muteHttpExceptions = true;
      }

      if (!url) {
        return null;
      }
      // eslint-disable-next-line no-undef
      const response = await fetch(url, options);
      if (response.status !== 200) {
        return null;
      }

      const imageBlob = await response.blob();
      return imageBlob;
    };

    const uploadFile = async (files) => {
      const { 0: file } = files;
      const image = await loadImageBlob(file?.link);
      if (image) {
        const file1 = new File([image], file?.name || 'n/a');
        setFileSelected({
          name: file.name,
          file: file1,
          source: 'dropbox'
        });
      }
      // this.onSuccess(files);
    };

    // drive google
    const uploadFromDrive = async (data) => {
      if (data && authResponse) {
        const { access_token } = authResponse;
        const { 0: file } = data.docs;
        const image = await loadImageBlob(
          `https://www.googleapis.com/drive/v3/files/${file?.id}?alt=media&source=downloadUrl`,
          access_token
        );

        if (image) {
          const file1 = new File([image], file?.name || 'n/a', { type: image.type });
          setFileSelected({
            name: file.name,
            file: file1,
            source: 'drive'
          });
        } else {
          setError('cv_file', { message: 'Ocurrio un error al cargar el archivo' });
        }
      }
    };

    const handleOpenPicker = (e) => {
      openPicker({
        clientId: `${clientAppDrive}.apps.googleusercontent.com`,
        developerKey: driveKey,
        viewId: 'DOCS',
        showUploadView: true,
        showUploadFolders: false,
        supportDrives: true,
        multiselect: false,
        viewMimeTypes: [
          'application/pdf',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.google-apps.document',
          'image/jpeg'
        ].join(),
        locale: 'es',
        callbackFunction: uploadFromDrive
      });
    };

    const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

    return (
      <HrFlexContainer flexDirection='column' alignItems='flex-start'>
        <HrTitleContainer borderBottom={darkMode ?  '1px solid #767676' : ''} >
          <HrTitleH4 fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''} isRequired={action !== editAction && vacancyRequirement.attached_file === obligatory}>
            {attachedFileLabel}
          </HrTitleH4>
        </HrTitleContainer>
        <FlexContainer>
          <HrTitleH5 fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''} >{t('postulant.curriculum.file_selected')}</HrTitleH5>
          <GridContainer>
            <HrCustomButton
              type='button'
              padding='6px'
              borderWidth='1px'
              fontSize='14px'
              minHeight='40px'
              height='40px'
              maxHeight='40px'
              color={darkMode ? 'white' : HrSecondary}
              backgroundColor={darkMode ? 'transparent' : HrWhite}
              borderColor={errors.cv_file ? HrRed : darkMode ? 'white' : HrSecondary}
              backgroundColorHover={ darkMode ? '#26293A' : HrButtonHover}
              backgroundColorActive={ darkMode ? '#26293A' : HrButtonActive}
              borderColorHover={ darkMode ? 'white' : ''}
              borderColorActive={ darkMode ? 'white' : '' }
              className='dropbox-button'
              onClick={() => {
                inputRef.current.click();
              }}
            >
              <span className='hr-Home' />
              {t('postulant.curriculum.button.myFiles')}
            </HrCustomButton>
            <DropboxChooser
              appKey='8438j5ehmiwemr2'
              success={uploadFile}
              linkType='direct'
              cancel={() => {}}
              extensions={['.pdf', '.doc', '.docx', '.jpg', '.jpeg']}
            >
              <HrCustomButton
                type='button'
                padding='6px'
                borderWidth='1px'
                fontSize='14px'
                minHeight='40px'
                height='40px'
                maxHeight='40px'
                color={darkMode ? 'white' : HrSecondary}
                backgroundColor={darkMode ? 'transparent' : HrWhite}
                borderColor={errors.cv_file ? HrRed : darkMode ? 'white' : HrSecondary}
                backgroundColorHover={ darkMode ? '#26293A' : HrButtonHover}
                backgroundColorActive={ darkMode ? '#26293A' : HrButtonActive}
                borderColorActive={ darkMode ? 'white' : '' }
                borderColorHover={ darkMode ? 'white' : ''}
                className='dropbox-button'
                width='100%'
              >
                <LogoDropbox width={20} height={23} />
                {t('postulant.curriculum.button.dropbox')}
              </HrCustomButton>
            </DropboxChooser>

            {/* <HrCustomButton
              type='button'
              padding='6px'
              borderWidth='1px'
              fontSize='14px'
              minHeight='40px'
              height='40px'
              maxHeight='40px'
              color={darkMode ? 'white' : HrSecondary}
              backgroundColor={darkMode ? 'transparent' : HrWhite}
              borderColor={errors.cv_file ? HrRed : darkMode ? 'white' : HrSecondary}
              backgroundColorHover={ darkMode ? '#26293A' : HrButtonHover}
              backgroundColorActive={ darkMode ? '#26293A' : HrButtonActive}
              borderColorHover={ darkMode ? 'white' : ''}
              borderColorActive={ darkMode ? 'white' : '' }
              className='dropbox-button'
              onClick={(e) => handleOpenPicker(e)}
            >
              <LogoDrive width={20} height={23} />
              {t('postulant.curriculum.button.driver')}
            </HrCustomButton> */}
          </GridContainer>
          <HrFlexContainer>
            <HrParagraph fontSizeSetting={fontSizeSetting} color={darkMode ? '#DADADA' : HrGrey}>{t('postulant.curriculum.description')}</HrParagraph>
          </HrFlexContainer>
          <InputFile
            inputRef={inputRef}
            inputFile={fileSelected}
            formState={formState}
            control={control}
            setError={setError}
            setInputFile={setFileSelected}
            clearErrors={clearErrors}
            register={register}
            setValue={setValue}
            name='cv_file'
            validate={{
              required: action !== editAction && vacancyRequirement.attached_file === obligatory,
              size: true, // { max: 5000000 },
              format: true
            }}
            trigger={trigger}
          />
        </FlexContainer>
      </HrFlexContainer>
    );
  }
);
